module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAAXNSR0IArs4c6QAAAEhQTFRFAAAAmpqamJiYmJiYmZmZmJiYmZmZmZmZmZmZmZmZmpqamZmZmZmZmZmZmpqamZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZCKdTFwAAABd0Uk5TAF1eYWZoaWtsbnR4j5icqOvs7ff4/f7ttAdMAAAAZElEQVQY063PORKAIBBE0VbcAFcE+v43NcCiGDB0wpdMfxz3CHHGb/CMS2mWPDFHoZYMPaBLtWRQgNBshRaWVdirlSWtDdAfBktWFelHbNuC0m2b+rHNtG0DfNvmsF+dnDy59QFryQtmooaaOAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/daas_case/close.png
// module id = 0dmS
// module chunks = 0